;(function () {
  'use strict'

  angular
    .module('contrast.settings.groups')
    .controller('ModalPermissionsDetailsCtrl', ModalPermissionsDetailsCtrl)

  function ModalPermissionsDetailsCtrl(
    $scope,
    $uibModalInstance,
    role,
    permissionRoles
  ) {
    'ngInject'

    angular.extend($scope, {
      role: role,
      permission: permissionRoles
    })

    angular.extend($scope, {
      cancel: cancel
    })

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
